import React from "react";
import PropTypes from "prop-types";

export const HomeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="20"
    fill="none"
    viewBox="0 0 24 20"
    {...props}>
    <path
      fill={props.selectedIcon ? "#448BCA" : "#6B778C"}
      fillRule="evenodd"
      d="M3 20a3 3 0 01-3-3V9.336a3 3 0 01.993-2.23l7-6.3a3 3 0 014.014 0l7 6.3A3 3 0 0120 9.336V17a3 3 0 01-3 3H3zM18 9.336V17a1 1 0 01-1 1h-3v-5a3 3 0 00-3-3H9a3 3 0 00-3 3v5H3a1 1 0 01-1-1V9.336a1 1 0 01.331-.743l7-6.3a1 1 0 011.338 0l7 6.3a1 1 0 01.331.743zM8 18v-5a1 1 0 011-1h2a1 1 0 011 1v5H8z"
      clipRule="evenodd"></path>
  </svg>
);

HomeIcon.propTypes = {
  selectedIcon: PropTypes.bool,
};
